import { Component, OnInit, Input, Inject } from '@angular/core';
import * as moment from 'moment';
import { AuthService } from '../core/auth/auth.service';
import { SortDirection, SortEvent } from '@allianz/ng-aquila/table';
import * as ExcelJS from 'exceljs/dist/exceljs.min.js';
import { AppConfig } from '../../config/app.config';


@Component({
  selector: 'app-salesreportmonthly',
  templateUrl: './salesreportmonthly.component.html',
  styleUrls: ['./salesreportmonthly.component.css'],
  standalone: false
})
export class SalesreportmonthlyComponent {
  @Input() policyStartDate: moment.Moment;
  @Input() policyEndDate: moment.Moment;

  fileName: string;
  ReportData: any;
  exportdata: any = [];
  _apiUrl: string;
  clientId: number;
  userTypeId: number;
  userBaseTypeId: number;
  userId: number;

  /** sorting starts here */

  sortTable(sort: SortEvent) {
    this.ReportData = this.ReportData.sort((a, b) => {
      if (sort.active in a && sort.active in b) {
        return this.compare(a[sort.active], b[sort.active], sort.direction);
      }
      return 0;
    });
  }

  compare(
    a: number | string | Date,
    b: number | string | Date,
    direction: SortDirection) {

    return (a < b ? -1 : 1) * (direction === 'asc' ? 1 : -1);
  }
  /** sorting ends here */
  /**Pagination Start */
  count: number = 0;
  pageNumber: number = 1;
  pageSize: number = 10;
  searchTerm: any = "";
  prevPage() {
    this.pageNumber--;
    this.getReportData();
  }

  nextPage() {
    this.pageNumber++;
    this.getReportData();
  }

  goToPage(n: number) {
    this.pageNumber = n;
    this.getReportData();
  }
  /**Pagination end */

  constructor(private authService: AuthService,
    private appConfig: AppConfig,) {
    this._apiUrl = appConfig.baseUrl;
    this.clientId = parseInt(atob(localStorage.getItem("CLIENT_ID")));
    this.userBaseTypeId = parseInt(atob(localStorage.getItem("USER_BASE_TYPE_ID")))
    this.userTypeId = parseInt(atob(localStorage.getItem("USER_TYPE_ID")))
  }


  loadReport() {
    this.getReportData()
  }

  getReportData() {
    var startdate = this.policyStartDate == undefined ? "" : this.policyStartDate.format('LL');
    var enddate = this.policyEndDate == undefined ? "" : this.policyEndDate.format('LL');

    this.authService.getList(this._apiUrl + `/api/v1/Report/GetSalesMonthReportWithPaging?pageNumber=${this.pageNumber}&pageSize=${this.pageSize}&searchText=${this.searchTerm}&startDatepicker=${startdate}&endDatepicker=${enddate}`)
      .subscribe(response => {
        if (response) {
          this.ReportData = response.body;
          let pagingProp = JSON.parse(response.headers.get('X-Pagination'));
          this.count = pagingProp.TotalCount;
          // this.ReportData.forEach(element => this.setExportData(element));
        }
      }, (error) => {

      });
  }
  exporttoexcel() {
    var startdate = this.policyStartDate == undefined ? "" : this.policyStartDate.format('LL');
    var enddate = this.policyEndDate == undefined ? "" : this.policyEndDate.format('LL');
    this.authService
      .getList(this._apiUrl + `/api/v1/Report/GetSalesMonthReport?startDatepicker=${startdate}&endDatepicker=${enddate}`)
      .subscribe(
        (response) => {
          if (response) {
            this.ReportData = response.body;
            this.fileName = "SalesMonthlyReport_" + new Date(Date.now()).toLocaleString().split(',')[0] + '.xlsx';
            /* json data is passed over here */
            var workbook = new ExcelJS.Workbook();
            var worksheet = workbook.addWorksheet('WorkshopReport');
            // Row 1: Merged main headers
            const headersRow1 = [
              'Zone', 'State', 'City', 'Dealer/WorkShop Code', 'Dealer/WorkShop Name', 'Payment Date',
              'January', '', 'February', '', 'March', '', 'April', '', 'May', '', 'June', '',
              'July', '', 'August', '', 'September', '', 'October', '', 'November', '', 'December', '', 'Total', ''
            ];

            worksheet.addRow(headersRow1);

            // Row 2: Subheaders under months
            const headersRow2 = [
              '', '', '', '', '', '',
              '#Count', '#Amount', '#Count', '#Amount', '#Count', '#Amount', '#Count', '#Amount',
              '#Count', '#Amount', '#Count', '#Amount', '#Count', '#Amount', '#Count', '#Amount',
              '#Count', '#Amount', '#Count', '#Amount', '#Count', '#Amount', '#Count', '#Amount'
            ];

            const monthMergeCols = [
              { label: 'January', start: 'G', end: 'H' },
              { label: 'February', start: 'I', end: 'J' },
              { label: 'March', start: 'K', end: 'L' },
              { label: 'April', start: 'M', end: 'N' },
              { label: 'May', start: 'O', end: 'P' },
              { label: 'June', start: 'Q', end: 'R' },
              { label: 'July', start: 'S', end: 'T' },
              { label: 'August', start: 'U', end: 'V' },
              { label: 'September', start: 'W', end: 'X' },
              { label: 'October', start: 'Y', end: 'Z' },
              { label: 'November', start: 'AA', end: 'AB' },
              { label: 'December', start: 'AC', end: 'AD' },
              { label: 'Total', start: 'AE', end: 'AF' }
            ];

            // Merge static columns (A–F)
            for (let i = 1; i <= 6; i++) {
              worksheet.mergeCells(1, i, 2, i);
            }

            // Merge month ranges
            monthMergeCols.forEach(({ start, end }) => {
              worksheet.mergeCells(`${start}1:${end}1`);
            });

            this.ReportData.forEach((item) => {
              const row = [
                item.zone,
                item.state_Name,
                item.city_Name,
                item.dealerOrWorkshopCode,
                item.workshop_Name,
                item.paymentDate,

                item.januaryCount, item.januaryAmount,
                item.februaryCount, item.februaryAmount,
                item.marchCount, item.marchAmount,
                item.aprilCount, item.aprilAmount,
                item.mayCount, item.mayAmount,
                item.juneCount, item.juneAmount,
                item.julyCount, item.julyAmount,
                item.augustCount, item.augustAmount,
                item.septemberCount, item.septemberAmount,
                item.octoberCount, item.octoberAmount,
                item.novemberCount, item.novemberAmount,
                item.decemberCount, item.decemberAmount,
                item.totalCount, item.totalAmount
              ];
              worksheet.addRow(row);
            });
            this.saveAsExcelFile(workbook, this.fileName);
          }
        },
        (error) => {

        }
      );
  }

  saveAsExcelFile(wb: any, fileName: string): void {
    wb.xlsx.writeBuffer().then((data) => {
      var blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      var a = window.document.createElement('a');
      var downloadUrl = window.URL.createObjectURL(blob);
      a.href = downloadUrl;
      a.download = `${fileName}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(downloadUrl);
    });
  }

}
